const leadFormURL = productPath => {
  return `${process.env.CWA_DOMAIN_NAME}${productPath || ''}`
}

export { leadFormURL }
